import RequestHandler from '../service/requeshandler'

export default {
    getRegistrationStatus: async () => {
        var response = await fetch(`googlesheet/registration/status/`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    searchMember: async (memberNo) => {
        var response = await fetch(`googlesheet/member/search/${memberNo}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    submitRegistrations: async (competitionType, registrations, recaptchaToken) => {
        var response = await fetch(`googlesheet/competition/registration/${competitionType}`, RequestHandler.createRequest('POST', registrations, recaptchaToken));
        return await RequestHandler.handleResponse(response);
    },
    getCompetition: async (competitionType, id) => {
        var response = await fetch(`googlesheet/competition/${competitionType}/${id}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    getCompetitions: async (competitionType) => {
        var response = await fetch(`googlesheet/competition/${competitionType}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    getPlayers: async (competitionType, sheetName) => {
        var response = await fetch(`googlesheet/competition/players/${competitionType}/${sheetName}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    getActivities: async () => {
        var response = await fetch(`googlesheet/activity`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    submitActivityRegistrations: async (email, registrations, recaptchaToken) => {
        var response = await fetch(`googlesheet/activity/registration/${email}`, RequestHandler.createRequest('POST', registrations, recaptchaToken));
        return await RequestHandler.handleResponse(response);
    },
    getRegistrations: async (competitionType, competitionId, registrationNumber) => {
        var response = await fetch(`googlesheet/registration/${competitionType}/${competitionId}/${registrationNumber}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    getActivityRegistrations: async (registrationNumber) => {
        var response = await fetch(`googlesheet/registration/activity/${registrationNumber}`, RequestHandler.createRequest('GET'));
        return await RequestHandler.handleResponse(response);
    },
    updateRegistrations: async (competitionType, competitionId, registrationNumber, registrations, recaptchaToken) => {
        var response = await fetch(`googlesheet/competition/registration/${competitionType}/${competitionId}/${registrationNumber}`, RequestHandler.createRequest('PUT', registrations, recaptchaToken));
        return await RequestHandler.handleResponse(response);
    },
    cancelRegistration: async (competitionType, competitionId, registrationNumber, playerName) => {
        var response = await fetch(`googlesheet/competition/registration/cancel/${competitionType}/${competitionId}/${registrationNumber}/${playerName}`, RequestHandler.createRequest('PUT'));
        return await RequestHandler.handleResponse(response);
    },
    cancelActivityRegistration: async (activityId, email, participantName) => {
        var response = await fetch(`googlesheet/activity/registration/cancel/${activityId}/${email}/${participantName}`, RequestHandler.createRequest('PUT'));
        return await RequestHandler.handleResponse(response);
    },
}